import { useContext } from 'react';
import { ILocationSummary } from 'gen/ApiClient';
import { CurrentLocationContext } from './CurrentLocationContext';

export function useCurrentLocation(): ILocationSummary | undefined {
	const { location } = useContext(CurrentLocationContext);

	return location;
}
